<template>
    <ModalCustom
        :is-open="state.isLoadModalOpen"
        @close="tryCloseLoadModal"
        title="Load Video"
        z-index="1001"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <loading-circle class="m-12" v-if="state.isLoading" />
            <div>
                <div class="mt-2">
                    <div class="flex gap-4 p-4">
                        <div
                            class="
                                grid grid-cols-3
                                gap-4
                                lg:grid-cols-4
                                flex-grow flex-shrink
                            "
                        >
                            <div
                                v-for="video in state.play?.videos"
                                :key="video.id"
                                class="
                                    pt-2
                                    px-4
                                    pb-4
                                    bg-white
                                    shadow-xl
                                    rounded-lg
                                    border border-gray-200
                                    text-center
                                    cursor-pointer
                                    hover:border-primary
                                "
                            >
                                <div class="flex mb-2">
                                    <div
                                        class="
                                            block
                                            text-md
                                            relative
                                            w-full
                                            text-center
                                        "
                                    >
                                        {{ video.title }}
                                    </div>
                                    <context-menu>
                                        <li>
                                            <a
                                                class="
                                                    py-2
                                                    px-6
                                                    flex flex-row
                                                    items-center
                                                    text-left
                                                    gap-2
                                                    cursor-pointer
                                                    hover:bg-gray-300
                                                    rounded-lg
                                                "
                                                @click="untagPlay(video)"
                                            >
                                                <div
                                                    class="
                                                        flex-grow-1
                                                        flex-shrink-0
                                                        font-slab
                                                        mt-1
                                                    "
                                                >
                                                    Un-tag
                                                </div>
                                            </a>
                                        </li>
                                    </context-menu>
                                </div>
                                <div
                                    class="
                                        relative
                                        group
                                        text-sm
                                        md:text-base
                                        fit-content
                                        flex flex-col
                                        overflow-hidden
                                    "
                                >
                                    <VideoPlayer
                                        :thumbnail="video.thumbnail"
                                        :url="video.url"
                                    ></VideoPlayer>
                                </div>
                                <button
                                    class="
                                        bg-gradient-to-br
                                        from-primary
                                        to-primaryLight
                                        text-white
                                        rounded-lg
                                        p-1
                                        px-4
                                        mt-4
                                    "
                                    @click="loadVideo(video)"
                                >
                                    View
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { computed, onMounted, reactive, watch } from "vue";
import LoadingCircle from "./LoadingCircle.vue";
import ModalCustom from "./ModalCustom.vue";
import AppButton from "./AppButton.vue";
import VideoPlayer from "./VideoPlayer.vue";

const props = defineProps(["play", "whiteboardApi", "readOnly", "isOpen"]);
const emit = defineEmits(["loaded", "tagged", "saved", "closed"]);

const state = reactive({
    play: props.play || null,
    isLoadModalOpen: false,
    isLoading: false,
});

watch(
    () => props.play,
    (play) => {
        state.play = play;
    }
);

watch(
    () => props.isOpen,
    (isOpen) => {
        if (isOpen) {
            state.isLoadModalOpen = true;
        }
    }
);

const tryCloseLoadModal = () => {
    if (state.isLoading) return;

    emit("closed");
    state.isLoadModalOpen = false;
};

async function tryOpenModal() {
    state.isLoadModalOpen = true;
    state.isLoading = true;
    state.isLoading = false;
}

function loadVideo(video) {
    emit("loaded", video);

    state.isLoadModalOpen = false;
}

async function untagPlay(video) {
    if (!state.play) {
        return;
    }
    await axios.post("/plays/untag-video", {
        play_id: state.play.play_id,
        video_id: video.id,
    });
    state.play.videos = state.play.videos.filter((v) => v.id !== video.id);
    emit("tagged", state.play);
}
</script>

<style scoped></style>
